/* eslint-disable import/prefer-default-export */
export const HEADER_GCLB_GEOLOCATION = 'x-client-geo-location';
